import {DG_axiosNormal} from "../../../../../custom/axios/normal";
import {DG_axios} from "../../../../../custom/axios";

const url = `/dogoo/timekeeping-rest/v2.0/export-timekeeping`;
const urlProcess = `/dogoo/timekeeping-rest/v2.0/process-timekeeping`;
const urlSelectRow = `/dogoo/timekeeping-rest/v2.0/export-timekeeping/select-row`;
const urlDownload = `/dogoo/common-config-rest/v2.0/timekeeping/download-tool`;

export const exportTimekeeping = async(params) => {

    const config = {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/octet-stream',
        },
        params: params
    }

    const response = await DG_axiosNormal.post(
        `${url}`,{},config
    );
    return response.data || []
};

export const exportTimekeepingSelectRow = async(params, key) => {

    const config = {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
        },
        params: params
    }

    const response = await DG_axiosNormal.post(
        `${urlSelectRow}`,key,config
    );
    return response.data || []
};


export const  getProcessTimeEnginesApi = async() => {

    const response = await DG_axios.get(`${urlProcess}`)
    return response?.data || []
}

export const downloadTool = async(params) => {

    const config = {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/octet-stream',
        },
        params: params
    }

    const response = await DG_axiosNormal.post(
        `${urlDownload}`,{},config
    );
    return response.data || []
};


